/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StiDto } from '../../models/sti-dto';

export interface GetStis$Params {
  idIntervenant: string;
  idOt?: string;
}

export function getStis(
  http: HttpClient,
  rootUrl: string,
  params: GetStis$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<StiDto>>> {
  const rb = new RequestBuilder(rootUrl, getStis.PATH, 'get');
  if (params) {
    rb.query('idIntervenant', params.idIntervenant, {});
    rb.query('idOt', params.idOt, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<StiDto>>;
    })
  );
}

getStis.PATH = '/v2/stis';
